import React from 'react';
import { X, Plus, Minus, Trash2 } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import { useNavigate } from 'react-router-dom';

const CartDrawer = () => {
  const { items, isOpen, closeCart, total, updateQuantity, removeItem } = useCart();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleCheckout = () => {
    closeCart();
    navigate('/checkout');
  };

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/60 z-50"
        onClick={closeCart}
        data-testid="cart-overlay"
      />

      {/* Drawer */}
      <div className="fixed right-0 top-0 bottom-0 w-full max-w-md bg-[#0D0D0D] z-50 flex flex-col border-l border-white/10" data-testid="cart-drawer">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-white/10">
          <h2 className="font-['Bebas_Neue'] text-2xl tracking-wider">YOUR CART</h2>
          <button
            onClick={closeCart}
            className="p-2 text-[#A3A3A3] hover:text-white transition-colors"
            data-testid="close-cart"
          >
            <X size={24} />
          </button>
        </div>

        {/* Items */}
        <div className="flex-1 overflow-y-auto p-6 space-y-6">
          {items.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-[#A3A3A3]">Your cart is empty</p>
            </div>
          ) : (
            items.map((item) => (
              <div key={`${item.product.id}-${item.size}-${item.color}`} className="flex gap-4 pb-6 border-b border-white/10" data-testid={`cart-item-${item.product.id}`}>
                <div className="w-20 h-20 bg-[#1A1A1A] rounded overflow-hidden flex-shrink-0">
                  {item.product.images?.[0] && (
                    <img
                      src={item.product.images[0]}
                      alt={item.product.name}
                      className="w-full h-full object-cover"
                    />
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-medium truncate">{item.product.name}</h3>
                  <p className="text-sm text-[#A3A3A3]">
                    {item.size} / {item.color}
                  </p>
                  <p className="text-[#D4AF37] font-medium mt-1">
                    ${item.product.price.toLocaleString()}
                  </p>
                  <div className="flex items-center gap-2 mt-2">
                    <button
                      onClick={() => updateQuantity(index, item.quantity - 1)}
                      className="p-1 bg-[#1A1A1A] hover:bg-[#262626] transition-colors"
                      data-testid={`decrease-qty-${index}`}
                    >
                      <Minus size={14} />
                    </button>
                    <span className="w-8 text-center text-sm">{item.quantity}</span>
                    <button
                      onClick={() => updateQuantity(index, item.quantity + 1)}
                      className="p-1 bg-[#1A1A1A] hover:bg-[#262626] transition-colors"
                      data-testid={`increase-qty-${index}`}
                    >
                      <Plus size={14} />
                    </button>
                    <button
                      onClick={() => removeItem(index)}
                      className="p-1 ml-2 text-red-500 hover:text-red-400 transition-colors"
                      data-testid={`remove-item-${index}`}
                    >
                      <Trash2 size={14} />
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Footer */}
        {items.length > 0 && (
          <div className="p-6 border-t border-white/10 space-y-4">
            <div className="flex justify-between text-lg">
              <span>Subtotal</span>
              <span className="text-[#D4AF37] font-['Bebas_Neue'] text-2xl" data-testid="cart-total">
                ${total.toLocaleString()}
              </span>
            </div>
            <p className="text-xs text-[#A3A3A3]">Shipping calculated at checkout</p>
            <button
              onClick={handleCheckout}
              className="w-full py-4 bg-[#D4AF37] text-black font-medium uppercase tracking-wider hover:bg-[#E5C048] transition-colors"
              data-testid="checkout-button"
            >
              Checkout
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default CartDrawer;
